import db from '@/firebase/init'

export default {

    methods: {

        chartFridge() {

            this.chartError = null
      
            db.collection("devices/" + this.chartDev.id + "/logs").doc(
              this.getFlatDate(this.vjsdpDate)).get().then((doc) => {
                if (doc.exists) {
      
                    var events = {doorO:[], doorC:[]}
                    var data = {fridgeT:[], condT:[]}
                    var min = null
                    var d = doc.data().rows
      
                    for(var i in d) {
      
                      // generate event time labels
                      var date = new Date(d[i].time);
                      if(date.getHours() < this.hours.h0 || date.getHours() > this.hours.h1 - 1) { continue; }
                      
                      // copy data
                      for(var field in data) {
                        if(field in d[i]) {
                          data[field].push({x: date, y: d[i][field]})
                          if((field == 'fridgeT' || field == 'condT') && (min == null || min > d[i][field])) {
                            min = d[i][field]
                          }
                        }
                      }
      
                      // events handling
                      if('doorOpen' in d[i]) {
                        events['door' + (d[i].doorOpen ? 'O' : 'C')].push({x: date})
                      }
      
                    }
      
                    var err = this.handleChartPoints(data, events, Math.trunc(min))
                    if(err) {
                      this.setChartError(err)
                      return
                    }
      
                    this.chartOptions = this.defaultChartOptions
      
                    this.chartData = {
                      type: 'line',
                      datasets: [
                        this.getChartLineData({
                          type: 'line',
                          color: 'blue',
                          spec: {
                            label: this.$t('fridge.fridgeT') + ', °C',
                            data: data.fridgeT
                          }
                        }),
                        this.getChartLineData({
                          type: 'line',
                          color: 'red',
                          spec: {
                            label: this.$t('fridge.condT') + ', °C',
                            data: data.condT
                          }
                        }),
                        this.getChartLineData({
                          type: 'event',
                          color: 'red',
                          spec: {
                            label: '▲ ' + this.$t('fridge.doorO'),
                            data: events.doorO,
                            pointStyle: 'triangle'
                          }
                        }),
                        this.getChartLineData({
                          type: 'event',
                          color: 'green',
                          spec: {
                            label: '● ' + this.$t('fridge.doorC'),
                            data: events.doorC,
                            pointStyle: 'circle'
                          }
                        })
                      ]
                    }
      
                } else {
                    this.setChartError(this.$t('common.nodoc'))
                }
            }).catch((error) => {this.setChartError(error)})
          }

    }

}


// WEBPACK FOOTER //
// ./src/components/Charts/Fridge.js